// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/rfi_source_versions.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { ListRfiSourceVersionsRequest, ListRfiSourceVersionsResponse, RecordRfiSourceVersionRequest, RecordRfiSourceVersionResponse, ReviewRfiSourceVersionRequest, ReviewRfiSourceVersionResponse } from "./rfi_source_versions_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * All methods authorize the RFI through Cerbos first. Tenant and actor come from
 * the authenticated gateway principal.
 *
 * @generated from service mono.projectdata.v1.RfiSourceVersionsService
 */ export const RfiSourceVersionsService = {
    typeName: "mono.projectdata.v1.RfiSourceVersionsService",
    methods: {
        /**
     * @generated from rpc mono.projectdata.v1.RfiSourceVersionsService.ListRfiSourceVersions
     */ listRfiSourceVersions: {
            name: "ListRfiSourceVersions",
            I: ListRfiSourceVersionsRequest,
            O: ListRfiSourceVersionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Records an already-linked RFI document as the next source version and computes the change review.
     *
     * @generated from rpc mono.projectdata.v1.RfiSourceVersionsService.RecordRfiSourceVersion
     */ recordRfiSourceVersion: {
            name: "RecordRfiSourceVersion",
            I: RecordRfiSourceVersionRequest,
            O: RecordRfiSourceVersionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiSourceVersionsService.ReviewRfiSourceVersion
     */ reviewRfiSourceVersion: {
            name: "ReviewRfiSourceVersion",
            I: ReviewRfiSourceVersionRequest,
            O: ReviewRfiSourceVersionResponse,
            kind: MethodKind.Unary
        }
    }
};
